export default "__VITE_ASSET__DuRcUkIf__"